import moment from 'moment';
import queryString from 'qs';

const getOperatorPresenceRequest = (filter) => {
  const queries = {
    limit: 10,
    page: filter?.page,
    operatorId: filter?.userId || filter?.id,
    monthYear: moment(filter?.paramsMonthYear || filter?.monthYear).format('MM-YYYY'),
    sort: 'createdAt.desc',
  };

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getOperatorPresenceRequest;
